import { atom } from '~/observers/jotai'

import { PersonalTrainerExercises } from './types'

export const personalTrainerExercisesAtom = atom<
  PersonalTrainerExercises | undefined
>(undefined)
